<template>
    <div class="currency-container">
        <div class="currency-header">
            <span class="currency-add">Device</span>
            <v-tooltip bottom>
                <v-btn flat color="black" slot="activator" @click="addFacilityDeviceItem" class="item-add-button-icon">
                    <v-icon large color="indigo">mdi-plus</v-icon>
                </v-btn>
                <div>Add new device</div>
            </v-tooltip>
        </div>
        <div>
            <AppTable :data="facilityDevicesData" :owner="'device'" :saving="saving"
                @deleteItem="deleteFacilityDeviceItem" @saveItem="saveFacilityDevice" @cancelEdit="cancelEditFacilityDeviceItem"
                @editItem="editFacilityDeviceItem" class="currency-table" />
        </div>
     </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';

    import AppTable from '@/components/common/AppTable';

    export default {
        name: 'facility-device-settings',
        components: {
            AppTable
        },
        data() {
            return {
                saving: false
            };
        },
        computed: {
            ...mapGetters({ facilityDevices: 'getFacilityDevices' }),
            facilityDevicesData() {
                return {
                    items: [
                        ...this.facilityDevices
                    ]
                };
            }
        },
        methods: {
            ...mapActions([
                'deleteFacilityDevice',
                'addFacilityDevice',
                'editFacilityDevice',
                'cancelFacilityDeviceEdit',
                'changeFacilityDevice',
                'createNewFacilityDevice'
            ]),
            deleteFacilityDeviceItem(index) {
                this.deleteFacilityDevice(index);
            },
            addFacilityDeviceItem() {
                this.addFacilityDevice({
                    id: -1,
                    name: '',
                    editting: true,
                    editable: true
                });
            },
            editFacilityDeviceItem(facilityDeviceId) {
                this.editFacilityDevice(facilityDeviceId);
            },
            cancelEditFacilityDeviceItem() {
                this.cancelFacilityDeviceEdit();
            },
            saveFacilityDevice(payload) {
                this.saving = true;
                if (payload.id > 0) {
                    this.changeFacilityDevice(payload).then(() => {
                        this.saving = false;
                    });
                } else {
                    this.createNewFacilityDevice(payload.name).then(() => {
                        this.saving = false;
                    });
                }
            }
        }
    };
</script>
<style scoped>
.currency-container {
    padding-bottom: 26px;
}

.currency-header {
    font-size: 24px;
    padding-left: 24px;
    padding-bottom: 14px;
    margin-top: 10px;
}

.currency-table {
    margin: 0 26px;
}

.currency-add {
    margin-right: 15px;
}

@media screen and (max-width: 600px) {
    .currency-table {
        margin: 0 13px;
    }
    
    .card__text {
        padding-left: 8px;
        padding-right: 8px;
    }

    .currency-header {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/FacilityDeviceSettings.vue